import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { PrototypeHome } from './components/review/PrototypeHome';
import { VariantComparisonScreen } from './components/review/VariantComparisonScreen';
import { DemoModeScreen } from './components/review/DemoModeScreen';
import { ChallanListingScreen } from './components/screens/ChallanListingScreen';
import { PaymentSummaryScreen } from './components/screens/PaymentSummaryScreen';
import { PaymentSuccessScreen } from './components/screens/PaymentSuccessScreen';
import { FastagRechargeScreen } from './components/screens/FastagRechargeScreen';
import { ReviewModeHandle } from './components/shell/ReviewModeHandle';
import { usePrototypeStore } from './stores/prototypeStore';
import { useEffect } from 'react';

const IS_PROTOTYPE = true;

function AppRoutes() {
  const location = useLocation();
  const showReviewHandle =
    IS_PROTOTYPE && !['/', '/compare', '/demo'].includes(location.pathname);
  const theme = usePrototypeStore((s) => s.theme);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  return (
    <div className={theme === 'dark' ? 'dark' : ''}>
      <Routes>
        <Route path="/" element={<PrototypeHome />} />
        <Route path="/compare" element={<VariantComparisonScreen />} />
        <Route path="/demo" element={<DemoModeScreen />} />
        <Route path="/challan-listing" element={<ChallanListingScreen />} />
        <Route path="/payment-summary" element={<PaymentSummaryScreen />} />
        <Route path="/payment-success" element={<PaymentSuccessScreen />} />
        <Route path="/fastag-recharge" element={<FastagRechargeScreen />} />
      </Routes>
      {showReviewHandle && <ReviewModeHandle />}
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
